import _ from 'lodash';
import { MOBILE_CONTENT_WIDTH, MOBILE_WIDTH, SPACE_BETWEEN_MOBILE_ELEMENTS } from 'crazyEditor/core/constants/editorConstants';
import { elementDefinitions, elementTypes } from 'crazyEditor/components/Elements/index';
import { getElementDefinitionProps, isTextElement } from 'crazyEditor/core/elements/utils/elementDefinitionUtils';
import { PADDING_PROP_NAMES } from 'crazyEditor/core/constants/panelConstants';

const TYPE_CONVERSATION = {
  [elementTypes.VideoElement]: elementTypes.MobileVideoElement,
  [elementTypes.GalleryElement]: elementTypes.MobileGalleryElement,
  [elementTypes.TabsElement]: elementTypes.MobileTabsElement,
  [elementTypes.CrossSellGalleryElement]: elementTypes.MobileCrossSellGalleryElement,
};

const addFontSizeForTextElements = (desktopElement) => ({
  data: {
    compProps: {
      fontSize: _.get(desktopElement, 'data.compProps.fontSize')
    }
  }
});

const getMobileGalleryDataProps = ({
  data: {
    showThumbnails: false,
    showDottedNav: true,
    alwaysShowNavArrow: true
  },
  compProps: _.zipObject(PADDING_PROP_NAMES, _.times(PADDING_PROP_NAMES.length, _.constant(0)))
});

export function getMobileId(desktopId) {
  return `mobile_${desktopId}`;
}

function getMobileStructure(desktopElement) {
  const elementType = TYPE_CONVERSATION[desktopElement.type] ? TYPE_CONVERSATION[desktopElement.type] : desktopElement.type;
  const overrides = [];
  const elementDefinitionProps = getElementDefinitionProps(elementType);
  if (elementType === elementTypes.MobileGalleryElement) {
    overrides.push(getMobileGalleryDataProps);
  } else if (isTextElement(elementType)) {
    overrides.push(addFontSizeForTextElements(desktopElement));
  }
  return _.merge({
    desktopId: desktopElement.id,
    parentId: !_.isEmpty(desktopElement.parentId) ? getMobileId(desktopElement.parentId) : null,
    type: elementType,
    id: getMobileId(desktopElement.id),
    layout: _.merge({}, desktopElement.layout, elementDefinitionProps.defaultLayout),
    hidden: false,
    compProps: {
      zIndex: desktopElement.compProps.zIndex,
    },
    data: {
      compProps: {
        fontWeight: _.get(desktopElement.data.compProps, 'fontWeight', null),
        textDecoration: _.get(desktopElement.data.compProps, 'textDecoration', null),
        fontStyle: _.get(desktopElement.data.compProps, 'fontStyle', null),
        textAlign: _.get(desktopElement.data.compProps, 'textAlign', null),
      },
      fontSizeInPercentFromDesktop: desktopElement.data.fontSizeInPercentFromDesktop,
    }
  }, ...overrides);
}

function convertToMobileStructure(desktopElements) {
  const mobileElements = [];
  _.forEach(desktopElements, (desktopElement) => {
    const mobileElement = getMobileStructure(desktopElement);
    mobileElements.push(mobileElement);
  });
  return mobileElements;
}

export {
  convertToMobileStructure
};
